import api from "./index";

export interface WebinarsListParams {
  ids?: Array<string>;
  title?: string;
  companyId?: string;
  ownerId?: string;
  categoryId?: string;
  viewerId?: string;
  priceMin?: number;
  priceMax?: number;
  enabled?: boolean;
  locale?: string;
  startedAtMin?: Date;
  startedAtMax?: Date;
  finishedAtMin?: Date;
  finishedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  status?: "coming" | "running" | "finished";
  offset?: number;
  limit?: number;
  sort?: "title" | "startedAt" | "finishedAt" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: WebinarsListParams, options?: any) => {
  return api.WebinarApi.list(
    params.ids,
    params.title,
    params.companyId,
    params.ownerId,
    params.categoryId,
    params.viewerId,
    params.priceMin,
    params.priceMax,
    params.enabled,
    params.locale,
    params.startedAtMin,
    params.startedAtMax,
    params.finishedAtMin,
    params.finishedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.status,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
